import React from "react";
import "./catwhychoose.css";
import { Link } from "react-router-dom";

const features = [
  {
    icon: "/Images/why_feature_1.svg",
    title: "Quality Foods",
    description: "Praesent rutrum ligula ligula, eget viverra neque congue sed. Donec",
  },
  {
    icon: "/Images/why_feature_2.svg",
    title: "Table reservation",
    description: "Guarantee your spot, and enjoy a hassle-free dining experience with our",
  },
  {
    icon: "/Images/why_feature_3.svg",
    title: "Online Order",
    description: "Order online and savor the delicious flavors from the comfort of home",
  },
];

const IndianStreetChoose = () => {
  return (
    <section className="why-wrapper">
      <div className="why-left">
        <p className="why-subtitle">Why Choose Us</p>
        <h2 className="cat-why-title">Mandurah's Street Taste.</h2>
        <p className="cat-why-desc">
          We bring the taste of India’s streets to the heart of Mandurah.
        </p>
         <Link to="/view-our-menu">  <button className="why-btn">SEE DETAILS →</button></Link>
      </div>

      <div className="cat-why-right">
        {features.map((item, index) => (
          <div className="cat-why-card" key={index}>
            <img src={item.icon} alt={item.title} className="why-icon" loading="lazy"/>
            <h4>{item.title}</h4>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IndianStreetChoose;
